(function () {
  'use strict';

  // —— MOBILE DRAWER ————————————————————————————————————————————
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    var first = drawer.querySelector('a, button');
    if (first) first.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    document.body.style.overflow = '';
    if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
  }
  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  // Crossing the desktop breakpoint with the drawer open would otherwise
  // leave the body locked.
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 980 && drawer && drawer.hasAttribute('data-open')) closeDrawer();
  });

  // —— ENLARGE ——————————————————————————————————————————————————
  // Delegated, so it covers images Shopify renders on any template.
  var overlay = document.querySelector('[data-enlarge]');
  var oImg = document.querySelector('[data-enlarge-img]');
  var oCap = document.querySelector('[data-enlarge-caption]');

  function openEnlarge(src, alt) {
    if (!overlay || !oImg) return;
    oImg.src = src;
    oImg.alt = alt || '';
    if (oCap) oCap.textContent = alt || '';
    overlay.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
  }
  function closeEnlarge() {
    if (!overlay) return;
    overlay.removeAttribute('data-open');
    document.body.style.overflow = '';
    if (oImg) oImg.removeAttribute('src');
  }
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('img[data-zoom]');
    if (img) {
      // An image inside a link is a way through to the work, not an
      // object to inspect — navigation wins.
      if (img.closest('a')) return;
      e.preventDefault();
      openEnlarge(img.getAttribute('data-zoom-src') || img.currentSrc || img.src, img.alt);
      return;
    }
    if (e.target.closest && e.target.closest('[data-enlarge-close]')) { closeEnlarge(); return; }
    if (e.target.closest && e.target.closest('[data-enlarge-stage]') &&
        !(e.target.tagName === 'IMG')) { closeEnlarge(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (overlay && overlay.hasAttribute('data-open')) closeEnlarge();
    else if (drawer && drawer.hasAttribute('data-open')) closeDrawer();
  });

  // The ENLARGE badge hangs off the image's container, which the markup
  // doesn't know about — tag the parent so the affordance shows on touch,
  // where there is no cursor to change.
  function markZoomWraps() {
    document.querySelectorAll('img[data-zoom]').forEach(function (img) {
      if (img.closest('a') || img.closest('[data-hook="hero"]')) return;
      var p = img.parentElement;
      if (p && !p.hasAttribute('data-zoomwrap')) p.setAttribute('data-zoomwrap', '');
    });
  }
  markZoomWraps();

  // —— AUTOPLAYING VIDEO ————————————————————————————————————————
  // Muted must be set in JS as well as markup or some browsers refuse to
  // autoplay and the visitor lands on a frozen poster.
  document.querySelectorAll('video[autoplay]:not([data-lazy-video])').forEach(function (v) {
    v.muted = true; v.defaultMuted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  });


  // —— DEFERRED VIDEO ——————————————————————————————————————————
  // Below-the-fold film carries no src until the visitor approaches, so
  // the page never pays for it unless it is going to be seen.
  var lazyVideos = [].slice.call(document.querySelectorAll('video[data-lazy-video]'));
  if (lazyVideos.length) {
    var loadVideo = function (v) {
      if (v.getAttribute('data-loaded')) return;
      v.setAttribute('data-loaded', '1');
      v.muted = true; v.defaultMuted = true; v.loop = true;
      v.addEventListener('canplay', function () {
        v.style.opacity = '1';
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }, { once: true });
      v.src = v.getAttribute('data-src');
    };
    // Anything marked data-idle is not part of the initial page at all:
    // fetched after load, during idle time. The poster underneath is
    // already showing, so this is pure enhancement.
    var idle = lazyVideos.filter(function (v) { return v.hasAttribute('data-idle'); });
    var scrolled = lazyVideos.filter(function (v) { return !v.hasAttribute('data-idle'); });
    if (idle.length) {
      var startIdle = function () {
        var go = function () { idle.forEach(loadVideo); };
        if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 });
        else setTimeout(go, 1200);
      };
      if (document.readyState === 'complete') startIdle();
      else window.addEventListener('load', startIdle);
    }
    lazyVideos = scrolled;
    if ('IntersectionObserver' in window && lazyVideos.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { loadVideo(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: '600px 0px' });
      lazyVideos.forEach(function (v) { io.observe(v); });
    } else {
      var once = function () {
        lazyVideos.forEach(loadVideo);
        window.removeEventListener('scroll', once);
      };
      window.addEventListener('scroll', once, { passive: true });
    }
  }

  // —— INVITATION PANEL ————————————————————————————————————————
  // Corner panel, never a modal: it does not dim the page, does not block
  // clicks, and never covers the work. Suppressed on fine art and
  // anywhere in the buying flow.
  var panel = document.querySelector('[data-invite]');
  if (panel) {
    var KEY = 'cmg_invite_dismissed';
    var JOINED = 'cmg_invite_joined';
    var delay = parseInt(panel.getAttribute('data-delay') || '9', 10) * 1000;
    var shown = false, timer = null;

    function suppressed() {
      try {
        if (localStorage.getItem(JOINED)) return true;
        var d = localStorage.getItem(KEY);
        if (!d) return false;
        // Remember a dismissal for 120 days.
        return (Date.now() - parseInt(d, 10)) < 120 * 24 * 60 * 60 * 1000;
      } catch (e) { return false; }
    }

    function show() {
      if (shown || suppressed()) return;
      shown = true;
      panel.setAttribute('data-open', '');
      window.removeEventListener('scroll', onScroll);
      if (timer) clearTimeout(timer);
    }
    function onScroll() {
      if (window.scrollY > window.innerHeight * 0.18) show();
    }

    if (!suppressed()) {
      timer = setTimeout(show, delay);
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var dismiss = panel.querySelector('[data-invite-close]');
    if (dismiss) dismiss.addEventListener('click', function () {
      panel.removeAttribute('data-open');
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    });
    var form = panel.querySelector('form');
    if (form) form.addEventListener('submit', function () {
      try { localStorage.setItem(JOINED, '1'); } catch (e) {}
    });
  }
})();
